import { useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

// Page PUBLIQUE de retour après paiement sur place (QR comptoir) — le payeur n'est
// pas nécessairement connecté à l'app : aucune donnée sensible affichée.
export default function PaymentThanksPage() {
  const { t } = useAuth();
  const [searchParams] = useSearchParams();
  const cancelled = searchParams.get("cancelled") === "1";
  return (
    <div className="min-h-screen page-bg flex items-center justify-center p-6" data-testid="payment-thanks-page">
      <div className="app-card p-8 max-w-sm w-full text-center space-y-4">
        {cancelled
          ? <XCircle className="h-14 w-14 mx-auto t-secondary" />
          : <CheckCircle2 className="h-14 w-14 mx-auto text-emerald-400" />}
        <h1 className="font-heading text-2xl font-bold" data-testid="payment-thanks-title">
          {t(cancelled ? "pay.cancelled_title" : "pay.thanks_title")}
        </h1>
        <p className="text-sm t-secondary">{t(cancelled ? "pay.cancelled_body" : "pay.thanks_body")}</p>
      </div>
    </div>
  );
}
